import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

const styles = {
  block: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  noExpand: {
    flex: 'none',
  },
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  noFlex: {
    flexGrow: 0,
  },
};

const Block = ({
  className,
  classes,
  style = {},
  children,
  noExpand,
  centered,
  noFlex,
  ...otherProps
}) => {
  return (
    <div
      className={classNames(
        className,
        classes.block,
        noExpand ? classes.noExpand : undefined,
        centered ? classes.centered : undefined,
        noFlex ? classes.noFlex : undefined
      )}
      style={style}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export default injectSheet(styles)(Block);
